import { HamburgerNav, HamburgerSpan } from "./Hamburger.styled";

interface HamburgerProps {
  mobileNavOpen: boolean;
  showHideMobile: (bool: boolean) => void;
}


function HamburgerNavMenu({ mobileNavOpen, showHideMobile }: HamburgerProps) {
  const hamburger: React.MouseEventHandler<HTMLDivElement> = () => {
    showHideMobile(!mobileNavOpen);
  };

  return (
    <HamburgerNav onClick={hamburger}>
      <HamburgerSpan />
      <HamburgerSpan />
      <HamburgerSpan />
    </HamburgerNav>
  );
}

export default HamburgerNavMenu;
